import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect } from "@/components/common";

/** One-off quote items (not linked to finishing library or materials); added to cost, subtotal and total. */
export function CustomItems({ items = [], onChange }) {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div className="po-card p-4" data-testid="quote-custom-items">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-semibold text-[#13294B]">Custom items <span className="font-normal text-slate-500">· one-off lines not covered by materials or finishing</span></p>
        <Button size="sm" variant="outline" data-testid="quote-add-item" onClick={() => onChange([...items, { description: "", cost: 0, price: 0 }])}><Plus className="mr-1 h-4 w-4" />Add item</Button>
      </div>
      {items.map((it, i) => (
        <div key={i} className="mb-2 grid grid-cols-[1fr_7rem_7rem_2rem] items-end gap-2" data-testid={`quote-item-${i}`}>
          <Field label="Description"><Input data-testid={`quote-item-${i}-description`} value={it.description} onChange={(e) => set(i, "description", e.target.value)} /></Field>
          <Field label="Cost"><Input type="number" min="0" data-testid={`quote-item-${i}-cost`} value={it.cost} onChange={(e) => set(i, "cost", e.target.value)} /></Field>
          <Field label="Price"><Input type="number" min="0" data-testid={`quote-item-${i}-price`} value={it.price} onChange={(e) => set(i, "price", e.target.value)} /></Field>
          <button type="button" className="mb-2 text-slate-400 hover:text-rose-600" data-testid={`quote-item-${i}-remove`} onClick={() => onChange(items.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}

/** Additional discount as % or flat amount. */
export function DiscountInput({ f, setF, currency }) {
  const [mode, setMode] = useState(Number(f.manual_discount_amount) > 0 ? "amount" : "pct");
  const pick = (m) => { setMode(m); setF({ ...f, manual_discount_pct: 0, manual_discount_amount: 0 }); };
  const val = mode === "amount" ? f.manual_discount_amount : f.manual_discount_pct;
  return (
    <Field label="Additional discount">
      <div className="flex gap-2">
        <NativeSelect testId="quote-discount-mode" value={mode} onChange={pick} options={[{ value: "pct", label: "%" }, { value: "amount", label: currency || "Amount" }]} />
        <Input type="number" min="0" data-testid="quote-discount-input" value={val || 0}
          onChange={(e) => setF({ ...f, [mode === "amount" ? "manual_discount_amount" : "manual_discount_pct"]: Number(e.target.value || 0) })} />
      </div>
    </Field>
  );
}
